export default {
    navigateToRoute(route) {
        window.location.href = route
    }
}